import client from '@libs/HttpClient';

class PunchInOutService {
  //Attendance Master
  static listPunchInOut(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const selectedStatus = request.queryKey[3];
    const selectedEmployee = request.queryKey[4];
    const selectedMachineName = request.queryKey[5];
    const selectedPunchType = request.queryKey[6];
    const FromDate = request.queryKey[7];
    const ToDate = request.queryKey[8];
    const selectedTab = request.queryKey[9];
    return client.get(
      `/biometric?search=${searchText}&page=${page_no}&selectedStatus=${selectedStatus}&selectedEmployee=${selectedEmployee}&selectedMachineName=${selectedMachineName}&selectPunchType=${selectedPunchType}&FromDate=${FromDate}&ToDate=${ToDate}&selectedTab=${selectedTab}`,
      request
    );
  }

  static approverList(params) {
    const { type } = params.queryKey[1];
    return client.get(`/biometric-approver-list?type=${type}`);
  }

  static viewBioMetric(params) {
    return client.get(`/biometric/${params}/edit`);
  }
  static showBioMetric(params) {
    return client.get(`/biometric/${params}`);
  }


  static updateBioMetric(request) {
    return client.put(`/biometric/${request.id}`, request);
  }
  static punchInOutUpdateUser(request) {
    return client.patch(`/biometric/update-user/${request.id}`, request);
  }
  static changeStatusBioMetric(request) {
    return client.patch(`/biometric/change-status/${request.id}`, request);
  }

  static EmployeeList() {
    return client.get(`/biometric-approver-employee-list?all=1`);
  }
  static deleteBioMetric(request) {
    return client.delete(`/biometric/${request.id}`, request);
  }
  static ownPunchInOutList(request) {
    const page_no = request.queryKey[1];
    const selectedStatus = request.queryKey[2];
    const selectedTab = request.queryKey[3];
    const FromDate = request.queryKey[4];
    const ToDate = request.queryKey[5];
    return client.get(
      `/biometric/own/records?page=${page_no}&selectedStatus=${selectedStatus}&selectedTab=${selectedTab}&FromDate=${FromDate}&ToDate=${ToDate}`,
      request
    );
  }

}

export { PunchInOutService };
